import { DateTimezoneSetter } from "date-fns/parse/_lib/Setter";
import { User } from "./commonTypes";
import { SecurityOption } from "@diditusa/shared/types/productTypes";
import { Company } from "./companyTypes";

export interface GetUploadUrlResponse {
  signedUrl: string;
  fileId: number;
}

export interface GetUploadUrlRequest {
  entity: ImageEntity;

  purpose: ImagePurpose;

  productId?: number;

  fileName: string;

  userId?: string;

  companyId?: number;
}

export enum ImagePurpose {
  PROFILE = "PROFILE",
  PRODUCT = "PRODUCT",
  USER_VALIDATION = "USER_VALIDATION",
}

export enum ImageEntity {
  USER = "USER",
  PRODUCT = "PRODUCT",
}

export interface FileUpload {
  id: number;
  company?: Company;
  companyId?: number;
  user?: User;
  userId?: string;
  uploadedBy?: User;
  uploadedById: String;
  createdAt: Date;
  uploadedAt: Date;
  securityOption?: SecurityOption;
  securityOptionId?: number;
}
